import { config } from "@repo/config";
import {
	ApiKeysSettings,
	ApiKeysSettingsSkeleton,
} from "@saas/organizations/components/ApiKeysSettings";
import { AdminOnlyNotice } from "@saas/settings/components/SettingsLayout";
import { AsyncBoundary } from "@shared/components/AsyncBoundary";
import { orpc } from "@shared/lib/orpc";
import { dehydrateForLoader, getServerQueryClient } from "@shared/lib/server";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_saas/app/_org/$organizationSlug/settings/api-keys",
)({
	loader: async ({ context }) => {
		const queryClient = getServerQueryClient();
		if (context.isOrganizationAdmin) {
			await queryClient.ensureQueryData(
				orpc.apiKeys.list.queryOptions({
					input: { organizationId: context.organization.id },
				}),
			);
		}
		return {
			organizationId: context.organization.id,
			dehydratedState: dehydrateForLoader(queryClient),
		};
	},
	head: () => ({ meta: [{ title: `API keys - ${config.appName}` }] }),
	component: OrganizationApiKeysPage,
});

function OrganizationApiKeysPage() {
	const { isOrganizationAdmin } = Route.useRouteContext();
	const { organizationId, dehydratedState } = Route.useLoaderData();

	if (!isOrganizationAdmin) {
		return <AdminOnlyNotice what="API keys" />;
	}

	return (
		<AsyncBoundary
			fallback={<ApiKeysSettingsSkeleton />}
			dehydratedState={dehydratedState}
			errorFallback="inline"
		>
			<ApiKeysSettings organizationId={organizationId} />
		</AsyncBoundary>
	);
}
